import React from 'react';
import { Box, Typography, Stack } from '@mui/material';
import logo from '../images/logo.svg';
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';
import BookOnlineIcon from '@mui/icons-material/BookOnline';
import ThumbUpAltRoundedIcon from '@mui/icons-material/ThumbUpAltRounded';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import DashboardIcon from '@mui/icons-material/Dashboard';
import PeopleIcon from '@mui/icons-material/People';
import BarChartIcon from '@mui/icons-material/BarChart';
import ContentCutIcon from '@mui/icons-material/ContentCut';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { colors, typography, radius } from '../theme';

const CONTENT = {
    customer: {
        heading: 'Tempah Barber',
        headingAccent: 'Bila-Bila Masa',
        sub: 'Platform tempahan barber pertama anda — mudah, pantas, dan boleh dipercayai.',
        items: [
            { icon: <QrCodeScannerIcon sx={{ color: colors.primary, fontSize: 20 }} />, title: 'Walk-In dengan Imbasan QR', description: 'Datang terus ke kedai, imbas kod QR untuk mendaftar dengan pantas.' },
            { icon: <BookOnlineIcon sx={{ color: colors.primary, fontSize: 20 }} />, title: 'Tempahan Secara Dalam Talian', description: 'Tempah slot anda lebih awal melalui sistem atas talian yang mudah.' },
            { icon: <ThumbUpAltRoundedIcon sx={{ color: colors.primary, fontSize: 20 }} />, title: 'Barber Paling Disyorkan', description: 'Pilih barber yang paling dipercayai berdasarkan ulasan terbaik.' },
            { icon: <AccessTimeFilledIcon sx={{ color: colors.primary, fontSize: 20 }} />, title: 'Jangkaan Masa Giliran', description: 'Ketahui jangkaan masa menunggu sebelum hadir ke kedai.' },
        ],
    },
    owner: {
        heading: 'Urus Kedai Anda',
        headingAccent: 'Dengan Mudah',
        sub: 'Semua yang anda perlukan untuk mengurus kedai barber anda dalam satu platform.',
        items: [
            { icon: <DashboardIcon sx={{ color: colors.primary, fontSize: 20 }} />, title: 'Dashboard Masa Nyata', description: 'Pantau giliran, temujanji dan status barber secara langsung.' },
            { icon: <PeopleIcon sx={{ color: colors.primary, fontSize: 20 }} />, title: 'Urus Pasukan Barber', description: 'Tambah barber dengan kod jemputan dan pantau prestasi mereka.' },
            { icon: <QrCodeScannerIcon sx={{ color: colors.primary, fontSize: 20 }} />, title: 'Sistem Giliran QR', description: 'Pelanggan imbas QR untuk masuk giliran tanpa kaunter.' },
            { icon: <BarChartIcon sx={{ color: colors.primary, fontSize: 20 }} />, title: 'Laporan & Statistik', description: 'Lihat jumlah tempahan, walk-in dan populariti perkhidmatan.' },
        ],
    },
    barber: {
        heading: 'Sedia Untuk',
        headingAccent: 'Bekerja?',
        sub: 'Sertai kedai barber anda dan mula urus giliran anda sendiri hari ini.',
        items: [
            { icon: <ContentCutIcon sx={{ color: colors.primary, fontSize: 20 }} />, title: 'Dashboard Peribadi', description: 'Urus giliran dan temujanji anda sendiri dengan mudah.' },
            { icon: <NotificationsActiveIcon sx={{ color: colors.primary, fontSize: 20 }} />, title: 'Status Ketersediaan', description: 'Togol status tersedia atau tidak tersedia pada bila-bila masa.' },
            { icon: <CalendarMonthIcon sx={{ color: colors.primary, fontSize: 20 }} />, title: 'Jadual Harian', description: 'Lihat semua temujanji dan walk-in anda untuk hari ini.' },
            { icon: <ThumbUpAltRoundedIcon sx={{ color: colors.primary, fontSize: 20 }} />, title: 'Bina Reputasi', description: 'Kumpul ulasan dan bina nama anda dalam komuniti barber.' },
        ],
    },
};

const AuthContent = ({ role = 'customer' }) => {
    const content = CONTENT[role] ?? CONTENT.customer;
    return (
        <Box sx={{ maxWidth: 420, width: '100%' }}>
            <Box sx={{ display: 'flex', mb: 3 }}>
                <img src={logo} alt="DigitalQ" style={{ width: 80, height: 'auto' }} />
            </Box>
            <Typography sx={{ fontFamily: typography.poppins, fontSize: { xs: 24, md: 28 }, fontWeight: 700, color: colors.textPrimary, lineHeight: 1.2, mb: 1 }}>
                {content.heading}{' '}
                <Typography component="span" sx={{ fontFamily: typography.poppins, fontSize: { xs: 24, md: 28 }, fontWeight: 700, color: colors.primary }}>
                    {content.headingAccent}
                </Typography>
            </Typography>
            <Typography sx={{ fontSize: 13, color: colors.textFaint, mb: 4, lineHeight: 1.6 }}>
                {content.sub}
            </Typography>
            <Stack spacing={2.5}>
                {content.items.map((item, i) => (
                    <Box key={i} sx={{ display: 'flex', gap: 1.5, alignItems: 'flex-start' }}>
                        <Box sx={{ width: 36, height: 36, flexShrink: 0, bgcolor: colors.bgCard, border: `1px solid ${colors.border}`, borderRadius: radius.md, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            {item.icon}
                        </Box>
                        <Box>
                            <Typography sx={{ fontSize: 13, fontWeight: 600, color: colors.textPrimary, mb: 0.2 }}>{item.title}</Typography>
                            <Typography sx={{ fontSize: 12, color: colors.textFaint, lineHeight: 1.5 }}>{item.description}</Typography>
                        </Box>
                    </Box>
                ))}
            </Stack>
        </Box>
    );
};

export default AuthContent;